export const nonAllFeatures: any = [
	'modern-header',
	'disable-help-button',
	'disable-title-toolbar',
];
